import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import messages from "messages";
import { Button } from "react-bootstrap";
// components
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import { ReactComponent as ScheduleIsComplete } from "assets/svg/schedule-is-complete.svg";
// constants
import { SHOW_TUTORIAL_COMPLETE_MODAL } from "constants/showTutorialCompleteModal";
// hooks
import { useUser } from "contexts/UserContext";
// styles
import styles from "./styles.module.scss";

/**
 * renders a modal to notify user that the schedule has been created
 */
const ScheduleCreatedModal = () => {
  const { user } = useUser();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      window.localStorage.getItem(SHOW_TUTORIAL_COMPLETE_MODAL.key) ===
      SHOW_TUTORIAL_COMPLETE_MODAL.value
    ) {
      // check stripe state
      if (user?.has_stripe_account_connected) {
        setShow(true);
      }
    }
    window.localStorage.removeItem(SHOW_TUTORIAL_COMPLETE_MODAL.key);
  }, [user?.has_stripe_account_connected]);

  return (
    <ModalLayout
      size={"md"}
      show={show}
      onHide={() => setShow(false)}
      Header={
        <span className={styles["tutorial-complete-modal__title"]}>
          {messages.yourScheduleIsNowPublic}
        </span>
      }
      showHeaderDivider={false}
      Footer={
        <Button
          onClick={() => setShow(false)}
          className={styles["tutorial-complete-modal__btn"]}
        >
          {messages.gotIt}
        </Button>
      }
      dialogClassName={styles["tutorial-complete-modal__dialog"]}
      headerClass={styles["tutorial-complete-modal__header"]}
      bodyClass={styles["tutorial-complete-modal__body"]}
      footerClass={styles["tutorial-complete-modal__footer"]}
    >
      <ScheduleIsComplete className={styles["tutorial-complete-modal__img"]} />
      <p className={styles["tutorial-complete-modal__text"]}>
        {messages.yourAvailabilityWillBePosted}
        <Link
          className={styles["tutorial-complete-modal__link"]}
          target={"_blank"}
          rel="noopener noreferrer"
          to={"/professional-search"}
        >
          {messages.findProfessional}
        </Link>
      </p>
    </ModalLayout>
  );
};

export default ScheduleCreatedModal;
